/*
  Ebbrest: скрипт трёх сцен (sections/eb-night, eb-loop, eb-sides). Без библиотек.
  Подключается с defer из snippets/eb-head.liquid после eb.js; повторный запуск отсекается флагом window.__ebScenes.

  Что делает:
  - eb-night: ведёт липкую сцену по доле прокрутки p (0-1). Все величины ведёт этот скрипт, CSS scroll-driven
    не используется: в Safari до 26 его нет. Долю берёт у window.EB.onProgress (assets/eb.js), а если его нет,
    считает сам: один слушатель scroll, один кадр requestAnimationFrame, в кадре читается только scrollTop,
    размеры меряются заранее (при входе сцены на экран и при смене размера окна).
    Мина Horizon: от 990 px страницу крутит .page-wrapper, а не окно, поэтому scroll слушается на document
    в фазе перехвата, а позиция берётся у того элемента, который прокручивается.
  - eb-loop: включает бег воды, пока схема на экране, и ведёт счётчик °F (°C), если числа заданы в настройках.
  - eb-sides: ползунки красят половины кровати. Пока схема идёт через экран, ползунки ведёт прокрутка: оба уходят
    в холод, затем каждый приезжает в положение из настроек (холод и тепло). Человек сам поменял значение (мышь,
    касание, клавиша) или пришёл на ползунок с клавиатуры: прокрутка его больше не ведёт до перезагрузки страницы.
    Прокрутка пальцем, начатая с ползунка, привязку не снимает.
  - переключатель Cool / Warm общий для сцен: атрибут data-eb-mode на корне сцены.
  «Уменьшить движение»: класс is-live не ставится, сцены лежат статично, переключатели работают.
*/
(function () {
  if (window.__ebScenes) return;
  window.__ebScenes = true;

  var W = window, D = document, R = D.documentElement;
  var mq = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = !!(mq && mq.matches);
  var raf = W.requestAnimationFrame ? W.requestAnimationFrame.bind(W) : function (f) { return setTimeout(function () { f(Date.now()); }, 16); };
  var N = 96; /* число отрезков, на которые разбита кривая ночи */

  R.classList.add('eb-js');

  function $(el, s) { return el.querySelector(s); }
  function $$(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function clamp(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function toC(f) { return Math.round((f - 32) * 5 / 9); }
  function num(el, name) { var v = el.getAttribute(name); return v === null || v === '' ? NaN : parseFloat(v); }

  /* Что прокручивается: .page-wrapper на компьютере в Horizon, иначе документ. */
  function scroller() {
    var p = $(D, '.page-wrapper'), oy;
    if (p) {
      oy = W.getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
    }
    return D.scrollingElement || R;
  }
  var sc = null;

  /* Один кадр на всё: доля прокрутки липких сцен и короткие счётчики. */
  var items = [], tweens = [], hooks = [], scrolls = [], queued = false;

  function frame(now) {
    queued = false;
    var y = sc ? sc.scrollTop : 0, i, it, p;
    for (i = 0; i < items.length; i++) {
      it = items[i];
      if (!it.on || it.ext) continue;
      p = clamp((y + it.st - it.top) / it.span);
      if (p !== it.p) { it.p = p; it.fn(p); }
    }
    for (i = tweens.length - 1; i >= 0; i--) if (tweens[i](now)) tweens.splice(i, 1);
    /* ползунки eb-sides: кадр повторяется, пока они доезжают до места */
    var more = false;
    for (i = 0; i < scrolls.length; i++) if (scrolls[i].on && scrolls[i].fn(now)) more = true;
    if (tweens.length || more) req();
  }
  function req() { if (!queued) { queued = true; raf(frame); } }

  /* Видимость: одна на все сцены. */
  var io = 'IntersectionObserver' in W ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.target.__ebSee) e.target.__ebSee(e.isIntersecting); });
  }, { rootMargin: '20% 0px' }) : null;
  function see(el, fn) { if (!io) { fn(true); return; } el.__ebSee = fn; io.observe(el); }
  /* Строгая видимость для бесконечной анимации: без запаса, по самому рисунку. Иначе бег воды крутится за экраном. */
  var ioNow = 'IntersectionObserver' in W ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.target.__ebSeeNow) e.target.__ebSeeNow(e.isIntersecting); });
  }, { threshold: .1 }) : null;
  function seeNow(el, fn) { if (!ioNow) { fn(true); return; } el.__ebSeeNow = fn; ioNow.observe(el); }

  /* Переключатель Cool / Warm: один на страницу, сцены держатся вместе. */
  function setMode(m) {
    $$(D, '[data-eb-scene][data-eb-mode]').forEach(function (s) {
      s.setAttribute('data-eb-mode', m);
      $$(s, '[data-eb-mode-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-eb-mode-btn') === m ? 'true' : 'false');
      });
    });
    hooks = hooks.filter(function (h) { return D.contains(h.el); });
    hooks.forEach(function (h) { h.fn(m); });
  }
  D.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-eb-mode-btn]') : null;
    if (b) setMode(b.getAttribute('data-eb-mode-btn'));
  });

  /* Сцена ночи */
  function night(el) {
    var tr = $(el, '[data-eb-track]'), stage = $(el, '[data-eb-stage]'), svg = $(el, '[data-eb-svg]'),
      line = $(el, '[data-eb-line]'), trail = $(el, '[data-eb-trail]'), ghost = $(el, '[data-eb-ghost]'), room = $(el, '[data-eb-room]'),
      dot = $(el, '[data-eb-dot]'), bed = $(el, '[data-eb-bed]'), clock = $(el, '[data-eb-clock]'),
      phases = $$(el, '[data-eb-phase]'), pills = $$(el, '[data-eb-pill]');
    if (!tr || !stage || !svg || !line || !line.getTotalLength) return;

    var from = num(el, 'data-eb-from') || 1320, mins = num(el, 'data-eb-mins') || 540, stop = num(el, 'data-eb-stop') || 510;
    var T1 = 115, T2 = 475; /* минуты от начала оси: конец спуска и начало подъёма, те же числа в кривой ниже */
    var X0 = .08; /* доля ширины, где стоит начало оси времени; та же цифра в подписях оси в секции */
    var live = !reduced, w = 0, h = 0, pts = [], a = 0, b = 1, cur = 0, ph = -1, ck = '', dawn = false, warm = null, late = null;
    var it = { el: el, on: true, ext: false, p: -1, top: 0, span: 1, st: 0, fn: draw };

    function x(m) { return (w * (X0 + (1 - X0) * m / mins)).toFixed(1); }

    /* Кривая в пикселях карточки: так штрих не растягивается, а точка остаётся круглой. Меряется вне кадра. */
    function build() {
      var r = svg.getBoundingClientRect(), nw = Math.round(r.width), nh = Math.round(r.height), isWarm = el.getAttribute('data-eb-mode') === 'warm';
      if (!nw || !nh || (nw === w && nh === h && isWarm === warm)) return;
      w = nw; h = nh; warm = isWarm;
      var gap = Math.max(h * .22, 30), base = (warm ? h - gap : gap).toFixed(1), pl = (h * (warm ? .14 : .86)).toFixed(1);
      var d = 'M0 ' + base + 'H' + x(0) + 'C' + x(45) + ' ' + base + ' ' + x(55) + ' ' + pl + ' ' + x(T1) + ' ' + pl +
        'H' + x(T2) + 'C' + x(505) + ' ' + pl + ' ' + x(512) + ' ' + base + ' ' + w + ' ' + base;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      line.setAttribute('d', d);
      if (ghost) ghost.setAttribute('d', d);
      if (trail) trail.setAttribute('d', d);
      if (bed) bed.setAttribute('y', warm ? 24 : -12);
      el.style.setProperty('--eb-base', base + 'px');
      if (room) { room.setAttribute('x2', w); room.setAttribute('y1', base); room.setAttribute('y2', base); }
      var len = line.getTotalLength(), i, pt, xa = +x(0), xb = +x(stop);
      pts = []; a = 0; b = 1;
      for (i = 0; i <= N; i++) { pt = line.getPointAtLength(len * i / N); pts.push(pt.x, pt.y); }
      a = at(xa); b = at(xb);
    }

    /* доля длины кривой, на которой она проходит через x */
    function at(xv) {
      for (var i = 1; i <= N; i++) if (pts[i * 2] >= xv) return (i - 1 + (xv - pts[i * 2 - 2]) / ((pts[i * 2] - pts[i * 2 - 2]) || 1)) / N;
      return 1;
    }

    function measure() {
      var r = tr.getBoundingClientRect();
      it.st = parseFloat(W.getComputedStyle(stage).top) || 0;
      sc = scroller();
      it.top = r.top + sc.scrollTop;
      it.span = Math.max(1, tr.offsetHeight - stage.offsetHeight);
      it.p = -1;
    }

    function draw(p) {
      if (!pts.length) return;
      cur = p;
      el.style.setProperty('--eb-p', p.toFixed(4));
      var l = a + clamp((p - .04) / .9) * (b - a), f = l * N, i = Math.min(N - 1, f | 0), k = f - i,
        px = pts[i * 2] + (pts[i * 2 + 2] - pts[i * 2]) * k, py = pts[i * 2 + 1] + (pts[i * 2 + 3] - pts[i * 2 + 1]) * k;
      line.style.strokeDashoffset = (1 - l).toFixed(4);
      if (trail) trail.style.strokeDashoffset = (1 - l).toFixed(4);
      if (dot) dot.setAttribute('transform', 'translate(' + px.toFixed(1) + ' ' + py.toFixed(1) + ')');
      /* подпись точки: справа от неё, а у правого края слева, чтобы не уходила за карточку и не ложилась на подъём */
      var lt = px > w * .7;
      if (bed && lt !== late) { late = lt; bed.setAttribute('x', lt ? -12 : 12); bed.setAttribute('text-anchor', lt ? 'end' : 'start'); }

      var m0 = clamp((px / w - X0) / (1 - X0)) * mins, m = Math.round((from + m0) / 5) * 5, hh = Math.floor(m / 60) % 24, mm = m % 60,
        t = (hh % 12 || 12) + ':' + (mm < 10 ? '0' : '') + mm + (hh < 12 ? ' AM' : ' PM');
      if (clock && t !== ck) { ck = t; clock.textContent = t; }

      /* Фаза идёт по часам, а не по трети прокрутки: вечер до конца спуска кривой (T1), утро с начала подъёма (T2).
         Иначе «Switch it off.» включалось в 4:45 AM. Если фаз не три, делим прокрутку поровну. */
      var n = phases.length, idx = n === 3 ? (m0 < T1 ? 0 : m0 < T2 ? 1 : 2) : Math.min(n - 1, Math.floor(p * n));
      if (idx !== ph) {
        ph = idx;
        phases.forEach(function (e, j) { e.classList.toggle('is-active', j === idx); });
        pills.forEach(function (e, j) { e.setAttribute('aria-pressed', j === idx ? 'true' : 'false'); });
      }
      var dn = p > .8;
      if (dn !== dawn) { dawn = dn; stage.classList.toggle('is-dawn', dn); }
    }

    function refresh() {
      build();
      if (!live) return;
      measure();
      if (it.ext) draw(cur); else req();
    }

    el.classList.add('is-ready');
    if (live) el.classList.add('is-live');
    build();
    hooks.push({ el: el, fn: function () { build(); if (live) draw(cur); } });
    el.__ebRefresh = refresh;
    if (!live) return;

    measure();
    /* Общий помощник из eb.js, если он есть. Иначе свой расчёт в frame(). */
    var EB = W.EB || W.Eb;
    if (EB && typeof EB.onProgress === 'function') {
      try {
        EB.onProgress(tr, function (p) { if (typeof p === 'number' && p === p) draw(clamp(p)); }, { sticky: stage });
        it.ext = true;
      } catch (e) { it.ext = false; }
    }
    items.push(it);
    see(el, function (on) { it.on = on; if (on) refresh(); });
    pills.forEach(function (b, j) {
      b.addEventListener('click', function () {
        /* тап ведёт туда, где часы показывают время фазы из настроек: 10:00 PM, 2:00 AM, 6:30 AM это доли 0, 0,5 и 1 */
        var to = pills.length > 1 ? j / (pills.length - 1) : 0, top;
        if (it.ext && EB.scrollToProgress) { EB.scrollToProgress(tr, to, { sticky: stage }); return; }
        measure();
        top = Math.round(it.top - it.st + it.span * to);
        try { sc.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { sc.scrollTop = top; }
      });
    });
    draw(0);
    req();
  }

  /* Контур воды */
  function loop(el) {
    var temp = $(el, '[data-eb-temp]'), f = $(el, '[data-eb-f]'), c = $(el, '[data-eb-c]'), shown = null, run = 0, played = false;
    function put(v) {
      var r = Math.round(v);
      if (r === shown) return;
      shown = r; f.textContent = r + '°F'; c.textContent = '(' + toC(r) + '°C)';
    }
    function count() {
      if (!temp || !f || !c) return;
      var m = el.getAttribute('data-eb-mode'), a = num(temp, 'data-' + m + '-from'), b = num(temp, 'data-' + m + '-to'), id = ++run, t0 = 0;
      if (isNaN(a) || isNaN(b)) return;
      if (reduced) { put(b); return; }
      tweens.push(function (now) {
        if (id !== run) return true;
        if (!t0) t0 = now;
        var k = clamp((now - t0) / 900);
        put(a + (b - a) * (1 - (1 - k) * (1 - k)));
        return k >= 1;
      });
      req();
    }
    el.classList.add('is-ready');
    if (!reduced) el.classList.add('is-live');
    hooks.push({ el: el, fn: count });
    seeNow($(el, '[data-eb-loop-svg]') || el, function (on) {
      el.classList.toggle('is-inview', on);
      if (on && !played) { played = true; count(); }
    });
  }

  /* Две половины кровати */
  function sides(el) {
    var min = num(el, 'data-eb-min'), max = num(el, 'data-eb-max'), hasNum = !isNaN(min) && !isNaN(max), rs = [];
    $$(el, '[data-eb-range]').forEach(function (r) {
      var half = D.getElementById(r.getAttribute('data-eb-range')), out = half ? $(half, '[data-eb-val]') : null;
      if (!half || !out) return;
      function upd() {
        var v = r.value / 100, t, deg;
        if (hasNum) { deg = Math.round(min + (v + 1) / 2 * (max - min)); t = deg + '°F (' + toC(deg) + '°C)'; }
        else t = el.getAttribute(v < -.08 ? 'data-eb-cool' : v > .08 ? 'data-eb-warm' : 'data-eb-mid') || '';
        half.style.setProperty('--v', v);
        half.classList.toggle('is-warm', v > .08);
        if (out.textContent !== t) out.textContent = t;
        /* атрибут пишется только при смене текста: при ходе от прокрутки диктору нечего повторять */
        if (r.getAttribute('aria-valuetext') !== t) r.setAttribute('aria-valuetext', t);
      }
      /* конец пути берётся из разметки: Firefox и возврат по истории восстанавливают значения полей */
      var end = parseFloat(r.defaultValue);
      if (isNaN(end)) end = +r.value;
      if (!reduced && io && r.value !== r.defaultValue) r.value = r.defaultValue;
      r.addEventListener('input', upd);
      upd();
      rs.push({ r: r, upd: upd, end: end, step: r.step });
    });
    el.classList.add('is-ready');
    if (rs.length && !reduced && io) sidesScroll(el, rs);
  }

  /* Ползунки от прокрутки. Положение из разметки (настройки секции) это конец пути: его видит человек без скрипта
     и с «меньше движения». Первая часть пути: оба ползунка из середины уходят в холод. Вторая: каждый едет в своё
     положение из настроек.
     Доля пути считается двумя способами. Ползунки рядом со схемой (от 990 px): по середине схемы, 0 у нижнего края
     экрана, 1 у верхнего. Ползунки под схемой (телефон, планшет): по блоку «схема + ползунки», путь начинается,
     когда нижний ползунок вошёл в экран (его подписи концов шкалы ещё могут быть за краем), и кончается, когда схема наполовину ушла за верхний край; иначе первая
     половина хода шла бы под нижним краем экрана. */
  function sidesScroll(el, rs) {
    var box = $(el, '.eb-sides__bed') || el, ctl = $(el, '.eb-sides__ctl');
    var it = { el: el, on: false, cur: null, last: 0 }, done = false, hold = null;
    var cold = Math.min.apply(null, rs.map(function (x) { return x.end; }));
    if (cold > -40) cold = -80;
    function ease(k) { k = clamp(k); return k * k * (3 - 2 * k); }
    function goal() {
      var b = box.getBoundingClientRect(), c = ctl ? ctl.getBoundingClientRect() : null, h = W.innerHeight, k1, k2, q, span;
      if (c && c.top >= b.bottom - 1) {
        span = Math.max(h - (c.bottom - b.top) + b.height * .5, h * .4);
        q = (h + 24 - c.bottom) / span; /* 24 px: подписи концов шкалы под нижним ползунком могут быть ещё за краем */
        k1 = ease((q - .04) / .4); k2 = ease((q - .54) / .4);
      } else {
        q = 1 - (b.top + b.height / 2) / h;
        k1 = ease((q - .14) / .28); k2 = ease((q - .5) / .26);
      }
      return rs.map(function (x) { return cold * k1 + (x.end - cold) * k2; });
    }
    function write() {
      rs.forEach(function (x, i) {
        var v = String(Math.round(it.cur[i]));
        if (x.r.value !== v) { x.r.value = v; x.upd(); }
      });
    }
    it.fn = function (now) {
      var g = goal(), dt = it.last ? Math.min((now - it.last) / 1000, .05) : 0;
      var k = it.cur ? 1 - Math.exp(-dt / .09) : 1, busy = false;
      it.cur = g.map(function (v, i) {
        var n = it.cur ? it.cur[i] + (v - it.cur[i]) * k : v;
        if (Math.abs(v - n) < .4) n = v; else busy = true;
        return n;
      });
      /* палец лежит на ползунке и ещё не ясно, тянет он его или листает страницу: значение не трогаем */
      if (!hold || hold.vert) write();
      it.last = busy ? now : 0;
      return busy;
    };
    /* человек взялся за ползунок сам (или включил «меньше движения»): дальше прокрутка его не ведёт */
    function stop(toEnd) {
      if (done) return;
      done = true;
      hold = null;
      it.on = false;
      scrolls = scrolls.filter(function (s) { return s !== it; });
      if (io) io.unobserve(el);
      rs.forEach(function (x) {
        x.r.step = x.step || '5';
        if (toEnd === true) x.r.value = x.end;
        x.upd();
      });
    }
    /* вернуть ползунки туда, куда их ведёт прокрутка */
    function back() { if (done) return; if (it.cur) write(); req(); }
    /* Касание. Прокрутка пальцем, начатая с ползунка, привязку не снимает: значение, которое браузер успел
       поставить под палец, возвращается. Привязку снимает только касание, которое поменяло значение и не стало
       вертикальной прокруткой (браузер не прислал touchcancel, сдвиг по вертикали не больше сдвига вбок). */
    function tStart(e) {
      var p = e.touches && e.touches[0];
      if (done || !p) return;
      hold = { x: p.clientX, y: p.clientY, input: false, vert: false };
    }
    function tMove(e) {
      var p = e.touches && e.touches[0], dx, dy;
      if (!hold || hold.vert || !p) return;
      dx = Math.abs(p.clientX - hold.x); dy = Math.abs(p.clientY - hold.y);
      if (dy > 8 && dy > dx) { hold.vert = true; back(); }
    }
    function tEnd() {
      var h = hold;
      hold = null;
      if (!h || done) return;
      if (h.input && !h.vert) stop(); else back();
    }
    function tCancel() { hold = null; back(); }
    function onInput() {
      if (done) return;
      if (!hold) { stop(); return; }   /* мышь, клавиатура, диктор */
      if (hold.vert) back(); else hold.input = true;
    }
    function onDown(e) { if (e.pointerType === 'mouse' || e.pointerType === 'pen') stop(); }
    /* фокус с клавиатуры: человек получает конец пути (холод и тепло), как без скрипта, и дальше ведёт сам;
       диктору после этого прокрутка ничего не объявляет. Фокус от касания привязку не снимает. */
    function onFocus(e) {
      var kb = false;
      try { kb = e.target.matches(':focus-visible'); } catch (err) { kb = !hold; }
      if (kb && !hold) stop(true);
    }
    rs.forEach(function (x) {
      x.r.step = '1'; /* шаг 5 оставлен клавишам; от прокрутки ползунок едет без ступенек */
      x.r.addEventListener('pointerdown', onDown);
      x.r.addEventListener('touchstart', tStart, { passive: true });
      x.r.addEventListener('touchmove', tMove, { passive: true });
      x.r.addEventListener('touchend', tEnd, { passive: true });
      x.r.addEventListener('touchcancel', tCancel, { passive: true });
      x.r.addEventListener('keydown', function () { stop(); });
      x.r.addEventListener('focus', onFocus);
      x.r.addEventListener('input', onInput);
    });
    el.__ebSidesStop = stop;
    scrolls.push(it);
    see(el, function (on) {
      if (done) return;
      it.on = on;
      it.cur = null; /* вход и выход: встать на место без доводки, секция за краем экрана */
      it.last = 0;
      if (on) req(); else it.fn(0);
    });
  }

  var kinds = { night: night, loop: loop, sides: sides };
  function init(root) {
    $$(root || D, '[data-eb-scene]').forEach(function (el) {
      var k = kinds[el.getAttribute('data-eb-scene')];
      if (!k || el.__ebOn) return;
      el.__ebOn = true;
      try { k(el); } catch (e) { if (W.console) W.console.error(e); }
    });
  }

  /* Размеры: смена окна и сдвиг страницы (догрузились картинки выше сцены). */
  var timer = 0;
  function relayout() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      $$(D, '[data-eb-scene="night"]').forEach(function (el) { if (el.__ebRefresh) el.__ebRefresh(); });
    }, 150);
  }
  /* Свой слушатель прокрутки нужен, только если долю сцены не ведёт EB.onProgress из eb.js. */
  function onScroll() {
    var i;
    for (i = 0; i < scrolls.length; i++) if (scrolls[i].on) { req(); return; }
    for (i = 0; i < items.length; i++) if (items[i].on && !items[i].ext) { req(); return; }
  }
  D.addEventListener('scroll', onScroll, { passive: true, capture: true });
  /* «Уменьшить движение» включили во время визита: сцены ложатся статично. Обратно включается после перезагрузки. */
  function onReduced(r) {
    if (!r || reduced) return;
    reduced = true;
    $$(D, '[data-eb-scene="night"],[data-eb-scene="loop"]').forEach(function (el) { el.classList.remove('is-live'); });
    $$(D, '[data-eb-scene="sides"]').forEach(function (el) { if (el.__ebSidesStop) el.__ebSidesStop(true); });
  }
  if (W.EB && typeof W.EB.onReduced === 'function') W.EB.onReduced(onReduced);
  else if (mq && mq.addEventListener) mq.addEventListener('change', function (e) { onReduced(e.matches); });
  W.addEventListener('resize', relayout);
  W.addEventListener('load', relayout);
  if ('ResizeObserver' in W && D.body) new ResizeObserver(relayout).observe(D.body);

  /* Редактор темы: секцию перерисовали. */
  D.addEventListener('shopify:section:load', function (e) {
    items = items.filter(function (it) { return D.contains(it.el); });
    scrolls = scrolls.filter(function (it) { return D.contains(it.el); });
    init(e.target);
  });

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { init(D); }); else init(D);
})();
